module.exports = __webpack_public_path__ + "img/25.7f875b41.svg";